import { useWindowDimensions } from 'react-native-web'
import { ResponsiveValueOptions, UseMediaQueryReturn } from '@Interfaces/Hooks/UIInterface'

export const breakPoints = {
  bp_xs: 0,
  bp_sm: 600,
  bp_md: 900,
  bp_lg: 1199,
  bp_xl: 1536,
  bp_xxl: 1792,
} as const

type BreakpointKey = keyof typeof breakPoints
type BreakpointValue = (typeof breakPoints)[BreakpointKey]

type BreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export default function useMediaQuery(): UseMediaQueryReturn {
  const { width } = useWindowDimensions()
  const { bp_sm, bp_md, bp_lg, bp_xl, bp_xxl } = breakPoints

  const getResponsiveValue = ({ xs, sm, md, lg, xl, xxl }: ResponsiveValueOptions): unknown =>
    width > bp_xxl && xxl !== undefined
      ? xxl
      : width > bp_xl && xl !== undefined
        ? xl
        : width > bp_lg && lg !== undefined
          ? lg
          : width > bp_md && md !== undefined
            ? md
            : width > bp_sm && sm !== undefined
              ? sm
              : xs

  const getCurrentBreakpoint = (): BreakpointName =>
    width > bp_xxl
      ? 'xxl'
      : width > bp_xl
        ? 'xl'
        : width > bp_lg
          ? 'lg'
          : width > bp_md
            ? 'md'
            : width > bp_sm
              ? 'sm'
              : 'xs'

  return {
    getResponsiveValue,
    getCurrentBreakpoint,
  }
}
